module.exports = __webpack_public_path__ + "static/divider3-0240286ccef57bfd77fc009f745ad46b.svg";